import { Button, Dialog, DialogActions, DialogContent, Typography } from '@material-ui/core';
import { WarningRounded } from '@material-ui/icons';
import React, { useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { useIsMount } from '../../hooks/useOnChange';
import DialogTitleBlock from '../Modals/Dialog/DialogTitleBlock';

interface OwnProps {
  open: boolean;
  handleClose: () => void;
  handleConfirmOk: () => void;
  text: string;
  title?: string;
}

const ConfirmationDialog: React.FC<OwnProps> = ({
  open,
  handleClose,
  handleConfirmOk,
  text,
  title,
}) => {
  const { t } = useTranslation();
  const [disabled, setDisabled] = useState(false);
  const isFirstMount = useIsMount();

  useEffect(() => {
    if (!isFirstMount && open === true) {
      setDisabled(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const handleClick = () => {
    handleConfirmOk();
    setDisabled(true);
  };

  return (
    <Dialog
      maxWidth="lg"
      aria-labelledby="confirmation-dialog-title"
      open={open}
      onClose={handleClose}
    >
      {title && (
        <DialogTitleBlock
          icon={<WarningRounded />}
          title={t(title)}
          handleClose={handleClose}
          disabled={disabled}
        />
      )}
      <DialogContent dividers>
        <Typography>
          <Trans i18nKey={text} />
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={handleClose} color="primary">
          {t('app:cancel')}
        </Button>
        <Button onClick={handleClick} color="primary" variant="contained" disabled={disabled}>
          {t('app:ok')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
